import * as React from 'react';
import { type IFalconTheme, Typography, TypographyVariant, useTheme } from '@secretescapes/falcon';
import { useApplicationState } from '@utils/useApplicationState';
import { BullfinchFeatureFlags, useFeatureFlag } from '@utils/useFeatureFlag';
import { CombinedH1, Container, Subtitle, Title } from './TitleSection.styles';

interface TitleSectionProps {
  title: string | JSX.Element;
  subtitle: string | JSX.Element;
  theme?: IFalconTheme;
  className?: string;
  onClick?: () => void;
}

export const TitleSection = ({ title, subtitle, className, onClick }: TitleSectionProps) => {
  const { color } = useTheme();
  const { isMobile } = useApplicationState();
  const seoCombinedH1Enabled = useFeatureFlag(BullfinchFeatureFlags.seoCombinedH1Enabled);

  return (
    <Container className={className} isMobile={!!isMobile}>
      {seoCombinedH1Enabled ? (
        <CombinedH1 isMobile={!!isMobile}>
          <Subtitle
            variant={TypographyVariant.body}
            color={color.blackText}
            onClick={onClick}
            component="span"
          >
            {subtitle}
          </Subtitle>
          <Title variant={TypographyVariant.t3Serif} color={color.blackText} component="span">
            {title}
          </Title>
        </CombinedH1>
      ) : (
        <>
          <Typography variant={TypographyVariant.t3Serif} color={color.blackText} component="h2">
            {title}
          </Typography>
          <Subtitle
            variant={TypographyVariant.body}
            color={color.blackText}
            onClick={onClick}
            component="h1"
          >
            {subtitle}
          </Subtitle>
        </>
      )}
    </Container>
  );
};
